import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import {
  ICredentialsPartnerErrors,
  ICredentialsPartnerPayload,
} from "../../interfaces/configuration";
import { IValidation } from "../../interfaces/form";
import { ICredentialsModal } from "../../interfaces/modal";
import { ERRORS_MESSAGES } from "../../utils/constants";
import { validateInputs } from "../../utils/inputValidations";
import ModalBase from "./ModalBase";
import GenericForm from "../GenericForm";
import ConfirmChangesCredentials from "../configuration/ConfirmChangesCredentials";
import CredentialsPartner from "../forms/CredentialsPartner";

const { tokenRequired, ivaRequired, ivaOnlyNumbers } = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  {
    id: "api_token",
    type: "required",
    message: tokenRequired,
  },
  {
    id: "iva",
    type: "required",
    message: ivaRequired,
  },
  {
    id: "iva",
    type: "only-numbers",
    message: ivaOnlyNumbers,
  },
];

const CredentialsPartnerModal = ({
  open,
  onClose,
  carrier,
  handleChangeOfConfig,
}: ICredentialsModal) => {
  const [values, setValues] = useState(
    (carrier?.credentials || {}) as ICredentialsPartnerPayload
  );
  const [errors, setErrors] = useState({} as ICredentialsPartnerErrors);

  const handleSubmit = () => {
    const inputErrors = validateInputs(values, formValidations);
    setErrors(inputErrors);
    if (Object.keys(inputErrors).length === 0) {
      handleChangeOfConfig({
        _id: carrier._id,
        name: carrier.name,
        disabled: carrier.disabled,
        credentials: { ...values },
      });
      onClose();
    }
  };

  return (
    <ModalBase open={open} handleClose={onClose} maxWidth="md">
      <Grid container>
        <Typography className="f-s-18 m-b-20">
          Ingresa los datos de tu contrato con {carrier.name}
        </Typography>
        <GenericForm onSubmit={handleSubmit}>
          <CredentialsPartner
            values={values}
            setValues={setValues}
            errors={errors}
          />
        </GenericForm>

        <ConfirmChangesCredentials
          onClose={onClose}
          handleSubmit={handleSubmit}
        />
      </Grid>
    </ModalBase>
  );
};

export default CredentialsPartnerModal;
